import {
  IServiceRequestLog,
  TUseServiceRequestLogsOptions,
} from '@commenda/types/src/service-request/types';
import { SWRFetcher } from '@commenda/utils';
import useSWR, { KeyedMutator } from 'swr';
import { API_BASE_PATH } from './constants';

export const useServiceRequestTaskLogs = (
  filterOptions?: TUseServiceRequestLogsOptions
) => {
  const {
    eventType,
    triggeredById,
    userType,
    startDate,
    endDate,
    serviceRequestId,
  } = filterOptions ?? {};
  const query = new URLSearchParams();

  if (eventType) {
    query.append('eventType', eventType);
  }

  if (triggeredById) {
    query.append('triggeredById', triggeredById);
  }
  if (userType) {
    query.append('userType', userType);
  }

  if (startDate) {
    query.append('startDate', startDate.toISOString());
  }

  if (endDate) {
    query.append('endDate', endDate.toISOString());
  }

  if (serviceRequestId) {
    query.append('serviceRequestId', serviceRequestId);
  }

  const {
    data,
    error,
    mutate,
  }: {
    data?: { data: IServiceRequestLog[] };
    error?: unknown;
    mutate: KeyedMutator<unknown>;
  } = useSWR(
    `${API_BASE_PATH}/logs?${query.toString()}`,
    SWRFetcher(
      {
        method: 'GET',
      },
      undefined
    )
  );

  return {
    data,
    error,
    mutate,
  };
};
